import styled from "@emotion/styled";
var Container = /*#__PURE__*/ styled("div", {
    target: "e1mkpwes0"
})("position:relative;");
export { Container };
